import React from 'react'
import "./loader.css"

const LoadingBar = ({height="0.7%",color="green",marginBotton="2%",width="30vw"}) => {
  return (
   <>
   <div className="loader" style={
    {
        marginBottom:marginBotton,
        width,height,
    }
   }>
  <div className="loaderBar"
  style={{
    background:color
  }}></div>
</div>
   </>
  )
}

export default LoadingBar
